import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format, parseISO } from "date-fns";
import { ShieldAlert } from "lucide-react";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/audit").then(({ data }) => setRows(data)).catch(e => setErr(e.response?.data?.detail || "Denied"));
  }, []);

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground flex items-center gap-1.5">
          <ShieldAlert className="w-3 h-3" /> Immutable log
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Audit Log</h1>
      </div>

      {err && <Card className="p-5 border-red-500/60 border-l-[3px]"><div className="text-sm text-red-600">{err}</div></Card>}

      <Card className="p-0 divide-y divide-border">
        {rows.length === 0 && !err && <div className="p-10 text-center text-sm text-muted-foreground">No activity yet.</div>}
        {rows.map(a => (
          <div key={a.id} className="flex items-center gap-3 px-4 py-2.5 hover:bg-muted/40">
            <div className="w-8 h-8 rounded-full bg-slate-100 dark:bg-zinc-900 grid place-items-center text-xs font-semibold">{(a.user_name || "?")[0]}</div>
            <div className="flex-1 min-w-0">
              <div className="text-sm">
                <span className="font-semibold">{a.user_name}</span>
                <span className="text-muted-foreground"> {a.action}</span>{" "}
                <Badge variant="outline" className="text-[10px] font-mono">{a.entity}</Badge>
              </div>
              <div className="text-[10px] text-muted-foreground font-mono">{a.entity_id}</div>
            </div>
            <div className="text-[10px] font-mono text-muted-foreground text-right">
              {a.at ? format(parseISO(a.at), "dd MMM yyyy · HH:mm:ss") : ""}
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}
